import ExtraTimeModal from './extra-time-modal';
import OrderErrorModal from './fraudulent-order-modal';

export {
    ExtraTimeModal,
    OrderErrorModal,
};



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/modals/index.js
 **/